module.exports = __webpack_public_path__ + "media/images/mailer/thumb_184-d0375ac1c84d0a216d671bb78cd07375.jpg";